import { Box } from './style';
import useMediaQuery from '@mui/material/useMediaQuery';

// Component
import Image from 'next/image';
import Text from 'components/common/Text';
import FAQ from 'components/common/FAQ';

// Libs
import Translation from 'libs/Translation';

const CustomFAQ = ({ faq }) => {
    const mobileView = useMediaQuery('(max-width:600px)');
    
    return (
         <Box>
            <div className='row-flex flex-title'>
                {mobileView ?
                <Image
                    src="/nextasset/images/center/icon-6.png"
                    width={32}
                    height={32}
                    alt="text-icon"
                />
                :
                <Image
                    src="/nextasset/images/center/icon-6.png"
                    width={36}
                    height={36}
                    alt="text-icon"
                />
                }
                <Text 
                    color="#0D2439"
                    className="title"
                >
                    {Translation.t('title.FAQ')}
                </Text>
            </div>
            <FAQ faq={faq} />
        </Box>
    )
}
export default CustomFAQ